import { Skeleton } from "@core/components";

export function ViewerSkeleton() {
  return (
    <div className="flex h-screen w-full flex-col">
      {/* header bar */}
      <div className="flex h-14 shrink-0 items-center gap-3 border-b border-neutral-200 px-4">
        <Skeleton width="2rem" height="2rem" rounded="md" />
        <Skeleton width="14rem" height="1.25rem" rounded="md" />
        <Skeleton width="3.5rem" height="1.25rem" rounded="full" />
        <div className="ml-auto flex gap-2">
          <Skeleton width="2rem" height="2rem" rounded="md" />
          <Skeleton width="2rem" height="2rem" rounded="md" />
        </div>
      </div>
      {/* content area */}
      <div className="flex flex-1 items-center justify-center">
        <Skeleton width="60%" height="70%" rounded="lg" />
      </div>
    </div>
  );
}
